import header from '../modules/header/index';
import {Apptus} from '../modules/apptus/apptus';
import NewsletterAction from '../modules/newsletterAction';
import addScrollToTop from '../modules/addScrollToTop';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {console.log('allCampaigns')
  header();
  addScrollToTop();
  
  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });

  $(window).on('click', (e) => {
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
        Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
        Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})